<template>
  <div class="drink-details-component d-flex align-center j-between">
    <v-btn
      class="button-param"
      color="#4CAF50"
      depressed
      @click="showUpsaleWindow"
    >
      <font-awesome-icon icon="plus" />
    </v-btn>
    <span class="status-text">{{ upsaleLabel }}</span>
    <div
      class="status d-flex align-center justify-center"
      :class="{'active': isDrinksSuggested}"
      @click="setDetailStatus"
    >
      <font-awesome-icon icon="check" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'DrinkDetails',
    computed: {
      ...mapState({
        isDrinksSuggested: state => state.fastOrder.isDrinksSuggested,
        basket: state => state.baskets.basket,
        categories: state => state.categories.categoriesList,
        drinkSaleText: state => state.baskets.drinkSaleText,
        currentEditOrder: state => state.orders.currentEditOrder,
        upsaleLabel: state => state.newOrder.upsaleLabelText,
      }),
      getClientName () {
        return this.basket.client ? this.basket.client.name : ''
      },
      isNewClient () {
        return this.currentEditOrder &&
          this.currentEditOrder.client &&
          this.currentEditOrder.client.firstOrderId === this.currentEditOrder.id
      },
    },
    methods: {
      setDetailStatus () {
        this.$store.commit('fastOrder/setDrinkDetailsStatus', true)
      },
      openDrinkCategory () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', 'drinks')
      },
      showUpsaleWindow () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', 'upsales')
        this.$store.commit('fastOrder/setDrinkDetailsStatus', true)
      },
      changeCategory (id) {
        this.$store.commit('fastOrder/setMenuItemsLoading', true)
        this.$store
          .dispatch('categories/fetchFilialMenuSingleCategories', { id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit(
                'fastOrder/setMenuItemsList',
                res.data.data.menuItems,
              )
              this.$store.commit(
                'fastOrder/setCollectionsList',
                res.data.data.collections,
              )
            }
            this.$store.commit('fastOrder/setCurrentCollectionId', undefined)
            this.$store.commit('fastOrder/setMenuItemsLoading', false)
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .drink-details-component {
    padding: 12px 13px;
    margin-bottom: 12px;
    background-color: #e6f2e6;
    border-radius: 10px;

    .button-param {
      margin-right: 20px;

      svg {
        .fill-svg(#ffffff);
      }
    }

    .button-param {
      font-size: 25px;
      line-height: 1;
      width: 50px;
      height: 50px;
      min-width: 50px !important;
      padding: 0 !important;
    }

    .status {
      flex-shrink: 0;
      background-color: #c3e2c3;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      cursor: pointer;
      &.active {
        background-color: #4CAF50;
      }

      svg {
        width: 23px;
        height: 23px;
        .fill-svg(#ffffff);
      }
    }
  }
</style>
